/** Chemins de navigation de l'objet Groupement (fiche par objet sur route). */

/** Base de la page "Configuration des offres commerciales". */
export const GROUP_ADMIN_BASE = '/admin/offres';

/** Onglet du dashboard correspondant au listing des groupements. */
export const GROUP_TAB = 'groupement';

/** Listing des groupements (onglet du dashboard). */
export const groupListPath = `${GROUP_ADMIN_BASE}?tab=${GROUP_TAB}`;

/** Fiche de création d'un groupement. */
export const groupCreatePath = `${GROUP_ADMIN_BASE}/groupement/new`;

/** Fiche d'édition d'un groupement. */
export const groupFichePath = (id: string | number): string =>
    `${GROUP_ADMIN_BASE}/groupement/${id}`;

/** Route enfant (relative à `admin/offres`) gérant création (`new`) et édition (`:id`). */
export const GROUP_FICHE_ROUTE = 'groupement/:id';
